import { registerSuperProperties } from '../utils/tracking/mixpanel'
import './types'

// Must match the Optimizely flag key SAapp decides in FunnelOptimizelyHelper;
// the injected payload doesn't carry the key.
export const MATCH_SCREEN_REDESIGN_FLAG_KEY = 'fsm-970_funnel_match_screen_redesign'

/**
 * FSM-1076: the redesign flag (FSM-970) is decided server-side in SAapp and
 * injected as `window.matchScreenRedesign`, so the client SDK's DECISION
 * notification listener never sees it. Mirror the injected decision into
 * Mixpanel as a super property so match screen events can be broken down by
 * redesign variation.
 *
 * Reads `window.matchScreenRedesign` directly (normally reserved for
 * `useMatchScreenRedesign()`) because this must run at bootstrap, before React
 * mounts, so the very first tracked events already carry the property.
 */
export const registerRedesignDecision = () => {
  const variationKey = window.matchScreenRedesign?.variationKey
  // An empty variationKey means no real decision was made (flag off for the
  // page, or SAapp's error fallback) — skip to avoid registering a fake bucket
  if (variationKey) {
    registerSuperProperties({ [MATCH_SCREEN_REDESIGN_FLAG_KEY]: variationKey })
  }
}
